import { styled } from '@mui/material/styles';
import type { Theme } from '@mui/material/styles';

import type { LoaderBackdrop, LoaderOverlay } from 'ui/loader/loader.types';

const LOADER_Z_INDEX = 100;
const OVERLAY_OPACITY = 0.3;

const BACKDROP_COLOR: Record<LoaderBackdrop, (theme: Theme) => string> = {
  gray: (theme) => theme.palette.grey[100],
  white: (theme) => theme.palette.common.white,
  transparent: () => 'transparent',
};

const OVERLAY_COLOR: Record<LoaderOverlay, (theme: Theme) => string> = {
  ...BACKDROP_COLOR,
  navy: (theme) => theme.palette.tokens.navy[50],
};

interface LoaderRootProps {
  fullScreen: boolean;
  backdrop: LoaderBackdrop;
}

interface LoaderOverlayLayerProps {
  overlay: LoaderOverlay;
}

export const LoaderRoot = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fullScreen' && prop !== 'backdrop',
})<LoaderRootProps>(({ theme, fullScreen, backdrop }) => ({
  position: fullScreen ? 'fixed' : 'absolute',
  inset: 0,
  zIndex: LOADER_Z_INDEX,
  backgroundColor: BACKDROP_COLOR[backdrop](theme),
}));

export const LoaderOverlayLayer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'overlay',
})<LoaderOverlayLayerProps>(({ theme, overlay }) => ({
  position: 'absolute',
  inset: 0,
  opacity: OVERLAY_OPACITY,
  backgroundColor: OVERLAY_COLOR[overlay](theme),
}));

export const LoaderStatus = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  display: 'flex',
  transform: 'translate(-50%, -50%)',
});

export const VisuallyHidden = styled('span')({
  position: 'absolute',
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  borderWidth: 0,
});
